import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { useThemeStore } from '@/stores/theme';
import LoginTreasureViewOne from '@/themes/themeOne/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewTwo from '@/themes/themeTwo/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewThree from '@/themes/themeThree/loginTreasure/loginTreasureView.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'loginTreasureView',
  emits: ['getDepositClaim', 'resetShowTreasurePopup'],
  setup(__props, { emit: __emit }) {

const themeStore = useThemeStore()
const emits = __emit
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoginTreasureViewOne, { onResetShowTreasurePopup: resetShowTreasurePopup })
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(LoginTreasureViewTwo, {
            onGetDepositClaim: _cache[0] || (_cache[0] = () => emits('getDepositClaim')),
            onResetShowTreasurePopup: resetShowTreasurePopup
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(LoginTreasureViewThree, { onResetShowTreasurePopup: resetShowTreasurePopup })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})